import React, {
  createContext, FC, PropsWithChildren, useContext, useMemo, useState,
} from 'react';

export type LoadingSpinnerTypes = 'auth' | 'fetchRequests' | 'patientUpdateForm' |
  'getPatient' | 'addExpenseForm' | 'getVaultPatientDetails' | 'localizationCheck';

interface ILoadingSpinnerContext {
  setShowingLoadingSpinner: (type: LoadingSpinnerTypes, isShowing: boolean,) => void;
  isShowingLoadingSpinnerDict?: Partial<Record<LoadingSpinnerTypes, boolean>>,
  isShowing: boolean;
}

export const LoadingSpinnerContext = createContext<ILoadingSpinnerContext | null>(null);

export const LoadingSpinnerProvider:FC<PropsWithChildren> = (props) => {
  const [
    isShowingLoadingSpinner,
    setIsShowingLoadingSpinner,
  ] = useState<Partial<Record<LoadingSpinnerTypes, boolean>>>({});

  const setShowingLoadingSpinner = (
    type: LoadingSpinnerTypes,
    isShowing: boolean,
  ) => setIsShowingLoadingSpinner({
    ...isShowingLoadingSpinner,
    [type]: isShowing,
  });

  const isShowing = useMemo(() => (
    Object.values(isShowingLoadingSpinner)
      .some((value) => value)
  ), [isShowingLoadingSpinner]);

  return (
    <LoadingSpinnerContext.Provider
      value={{
        setShowingLoadingSpinner,
        isShowing,
        isShowingLoadingSpinnerDict: isShowingLoadingSpinner,
      }}
      {...props}
    />
  );
};

export const useLoadingSpinnerContext = () => {
  const context = useContext(LoadingSpinnerContext);
  if (!context) {
    throw new Error('useLoadingSpinnerContext should be used within LoadingSpinnerProvider');
  }
  return context;
};
